import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";

const NotificationModalBox = styled.div`
    z-index: 1;
    ${setFontVariant("listItem1", colorsPalettes.carbon[0])};
    box-sizing: border-box;
`;

const Title = styled.div`
    ${setFontVariant("listItem1", colorsPalettes.carbon[0])};
`;
const SubTitle = styled.div`
    ${setFontVariant("tooltip", colorsPalettes.carbon[0])};
`;

const StyledButton = styled(Button)`
    float: right;
    margin-top: 16px;
`;

const CloseBtnContainer = styled.div`
    position: absolute;
    right: 13px;
    top: 13px;
`;

const CloseIconButton = styled(SWReactIcons)`
    top: 13px;
    cursor: pointer;
    width: 13px;
    height: 13px;

    path {
        fill: ${colorsPalettes.carbon[0]};
    }
`;

interface INotificationModal {
    title?: string;
    subtitle?: string;
    btnText?: string;
    onBtnClick?: VoidFunction;
    onClose?: VoidFunction;
    classContiner?: string;
}

const NotificationModal: FC<INotificationModal> = ({
    title,
    subtitle,
    btnText,
    onClose,
    onBtnClick,
    classContiner,
}) => {
    return (
        <div data-automation="notificationModal">
            <NotificationModalBox className={classContiner}>
                {onClose ? (
                    <CloseBtnContainer onClick={onClose}>
                        <CloseIconButton iconName="clear" />
                    </CloseBtnContainer>
                ) : null}
                {title ? <Title>{title}</Title> : null}
                {subtitle ? <SubTitle>{subtitle}</SubTitle> : null}
                {onBtnClick ? (
                    <StyledButton
                        type="inverted"
                        onClick={onBtnClick}
                    >
                        {btnText}
                    </StyledButton>
                ) : null}
            </NotificationModalBox>
        </div>
    );
};

export default NotificationModal;
